const utils = {
  dotDelimitedGet: (obj, p, dv) => {
    const splitPath = p.split('.')
    let idx = 0
    let ret = obj

    while (ret && idx < splitPath.length) {
      ret = ret[splitPath[idx]]
      idx++
    }

    if (ret === undefined) {
      return dv !== undefined ? dv : undefined
    }
    return ret
  },
  allMeetCondition: (lambda, ...items) => {
    return !items.map((item) => lambda(item)).includes(false)
  },
  filterNumbersFromString: (s, radix = 10) => {
    // Note that this will handle negative signs because parseInt('-', 10) is NaN even if parseInt('-n', 10) (where n
    // is some number) isn't
    return Array.from(s)
      .filter((e) => !Number.isNaN(parseInt(e, radix)))
      .join('')
  },
}

export const shuffle = (arr, options) => {
  if (!Array.isArray(arr)) {
    throw new Error('shuffle expect an array as parameter.')
  }

  options = options || {}

  let collection = arr
  let len = arr.length
  const rng = options.rng || Math.random
  let random
  let temp

  if (options.copy === true) {
    collection = arr.slice()
  }

  while (len) {
    random = Math.floor(rng() * len)
    len -= 1
    temp = collection[len]
    collection[len] = collection[random]
    collection[random] = temp
  }

  return collection
}

export default utils
